import React from 'react';
import {useTranslation} from 'react-i18next';
import {TscButtonType} from '@techsmith/tsc-cloud-style-guide';
import '../../static/css/modal.less';
import withMemoizedContexts from '../../context/contextContainerHoC';
import {userQuotaStore} from '../../context/userQuotaProvider';
import config from '../../service/config';
import {AlertModalPortal} from '../util/ModalPortalHelper';

export const UserOverQuotaModalBase: React.FC<IUserOverQuotaProps & IUserOverQuotaStateMappedProps> = ({children, UserHasQuotaInformation, VideoCountExceeded}) => {
   const {t} = useTranslation();

   const [showQuotaAlert, setShowQuotaAlert] = React.useState(false);

   const userOverQuotaContainerClicked = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      e.stopPropagation();
      e.preventDefault();
      setShowQuotaAlert(true);
   };

   const openUpgradeLink = () => {
      window.open(config.environmentData.ScreencastProPurchaseLinkUrl, '_blank');
   };

   const isOverQuota = config.featureSwitches.EnableScreencastProEntitlement && UserHasQuotaInformation && VideoCountExceeded;

   // TODO: need some updated words here
   return isOverQuota ?
      showQuotaAlert ?
         (<>
            {children}
            <AlertModalPortal data-test-id={'user-over-quota-modal'}
               title={t('userQuotas.overQuotaModal.title')}
               onConfirm={() => setShowQuotaAlert(false)}
               confirmContent={t('general.close')}
               confirmButtonType={TscButtonType.primary}
               onClose={() => setShowQuotaAlert(false)}
               onDismiss={() => openUpgradeLink()}
               dismissContent={t('userQuotas.overQuotaModal.upgradeButton')}
               dismissButtonType={TscButtonType.secondary}
            >
               {t('userQuotas.overQuotaModal.body')}
            </AlertModalPortal>
         </>) :
         <div data-test-id={'user-over-quota-click-container'} onClick={userOverQuotaContainerClicked}>{children}</div> :
      <>{children}</>;
};

export interface IUserOverQuotaProps {
   children?: React.ReactNode;
}

export interface IUserOverQuotaStateMappedProps {
   VideoCountExceeded: boolean;
   UserHasQuotaInformation: boolean;
}

const mapStatesToProps = (
   {children}: IUserOverQuotaProps,
   {UserHasQuotaInformation, VideoCountExceeded}: Partial<IUserOverQuotaStateMappedProps>
): IUserOverQuotaProps & IUserOverQuotaStateMappedProps => ({children, UserHasQuotaInformation, VideoCountExceeded});

export default withMemoizedContexts(mapStatesToProps, userQuotaStore)(UserOverQuotaModalBase);
